import { VaultVIcon } from "../../assets/icons"
import { VaultAnalyzeCompleteStatusWrapper } from "./VaultStatuses.styles"

export const VaultAnalyzeCompleteStatus = ({ minimized }) => {
    if (minimized) {
        return <VaultVIcon />
    }

    return (
        <VaultAnalyzeCompleteStatusWrapper>
            <VaultVIcon />
            <div>Completed</div>
        </VaultAnalyzeCompleteStatusWrapper>
    )
}